<div
  id="chart-container-bar"
  *ngIf="!isObjectEmpty(dataset); else noDataTemplate"
>
  <div class="d-flex align-items-center">
      <!-- ── Header ───────────────────────────────────────────── -->
  <div class="hs-header">
    <span class="hs-title">{{metricDisplayName}}</span>
  </div>
    <div class="btn-div" *ngIf="isSeverity">
      <button
        class="btn overall-btn"
        (click)="showOverallData()"
        [ngClass]="{ active: isOverallActive }"
      >
        <span> Overall</span>
      </button>
      <select
        [ngClass]="{ active: !isOverallActive }"
        id="dropdown"
        [(ngModel)]="selectedTestSuite"
        class="custom-dropdown"
        (change)="onSelectionChange()"
      >
        <option value="" disabled selected>Test Suite</option>
        <option *ngFor="let option of testSuites" [value]="option">
          {{ option }}
        </option>
      </select>
    </div>
  </div>

  <ng-container>
    <p-chart [type]="chartType" [data]="chartData" [options]="chartOptions">
    </p-chart>
  </ng-container>
</div>
<ng-template #noDataTemplate>
  <app-no-data></app-no-data>
</ng-template>
